// do not translate this
export const FLAG_CONSTANTS = {
  SUPER_ADMIN_FLAG: "superadmin",
  ADMIN_FLAG: "ADMIN",
  USER_FLAG: "USER",
  RM_FLAG: "finance Manager",
  MANAGER: "MANAGER",
  CONTRACTOR: "contractor",
  PRIVATE_FLAG: "Private",
  PUBLIC_FLAG: "Public",
};

export const BOOLEAN_FLAGS = {
  TRUE: "true",
  FALSE: "false",
};
